import React, {useState, useEffect} from "react";
import {Button, Table, Card, Form, Select, Input, Row, Col, DatePicker, Modal} from "antd";
import {useModel} from "../../../models"
import BillModel from "./BillModel"
import CustomerBillService from "./CustomerBillService.js"

const {Option} = Select;
const {RangePicker} = DatePicker;

const CardSearch = () => {
    const [form] = Form.useForm();
    const [{BillParams, selectedCustomerRow}, {setBillParams, loadBillList}] = useModel('customerBill')
    // const [{ billsTypeDict,payeeTypeDict},{ getBillsTypeDict,getPayeeTypeDict }] = useModel("cmDict");
    useEffect(() => {

        // getBillsTypeDict()        
        // getPayeeTypeDict()
        // console.log(billsTypeDict,payeeTypeDict)
    }, [])
    const billTypeDict = [
        {key: "039001", label: "销售单", value: "销售单"},
        {key: "039002", label: "采购单", value: "采购单"},
        {key: "039003", label: "销售退货单", value: "销售退货单"},
        {key: "039004", label: "采购退货单", value: "采购退货单"},
    ]
    const payeeTypeDict = [
        {key: 1, label: "未收款", value: "0"},
        {key: 2, label: "已收款", value: "1"},
    ]
    const onFinsh = () => {
        let {keepTime, flatAccountTime, ...datas} = form.getFieldsValue()
        let bookStartDate = keepTime && keepTime.length != 0 ? keepTime[0].format("YYYY-MM-DDT00:00:00") : ""
        let bookEndDate = keepTime && keepTime.length != 0 ? keepTime[1].format("YYYY-MM-DDT23:59:59") : ""
        let balanceStartDate = flatAccountTime && flatAccountTime.length != 0 ? flatAccountTime[0].format("YYYY-MM-DDT00:00:00") : ""
        let balanceEndDate = flatAccountTime && flatAccountTime.length != 0 ? flatAccountTime[1].format("YYYY-MM-DDT23:59:59") : ""
        let data = {
            ...datas,
            bookStartDate,
            bookEndDate,
            balanceStartDate,
            balanceEndDate,
            relationId: selectedCustomerRow.id
        }
        // console.log(data)
        setBillParams(data)
        loadBillList({data})
        // let formData = form.getFieldsValue()
        // setBillParams(formData)
        // console.log(formData)
    }
    const onReset = () => {
        let data = {
            relationId: selectedCustomerRow.id
        }
        loadBillList({data})
        setBillParams(data)

        form.resetFields()
    }
    return (
        <Card>
            <Form
                form={form}
                name="customer_bill"
                labelCol={{span: 6}}
                onFinish={onFinsh}
                // onValuesChange={onChangeVal}
            >
                <Row>
                    <Col span={4}>
                        <Form.Item
                            name="documentType"
                            label="单据类型"
                        >
                            <Select placeholder="单据类型"
                                    allowClear={true}
                                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                                    options={billTypeDict}
                            >
                                {/* {WorkType.map((item)=>{
                                    return (<Option key={item.type} value={item.type}>{item.type}</Option>)
                                })} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="status"
                            label="收款状态"
                        >
                            <Select placeholder="收款状态"
                                    allowClear={true}
                                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                                    options={payeeTypeDict}
                            >
                                {/* {receiptStatus.map((item)=>{
                                    return (<Option key={item.type} value={item.type}>{item.type}</Option>)
                                })} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="keepTime"
                            label="记账日期"
                        >
                            <RangePicker/>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                        >
                            <Button type="primary" className="margin-left-8" type="primary"
                                    htmlType="submit">查询</Button>
                            <Button className="margin-left-8" onClick={onReset}>重置</Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={4}>
                        <Form.Item
                            name="documentNumber"
                            label="单据编号"
                        >
                            <Input placeholder="单据编号"/>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="flatAccountTime"
                            label="平账日期"
                        >
                            <RangePicker style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}
const TableHeader = () => {
    const [{BillModelType, BillTable, BillParams, BillPage, selectedCustomerRow}, {setBillModelType}] = useModel('customerBill')
    const onDetail = () => {
        setBillModelType(!BillModelType)
    }
    const onExport = () => {
        // return  console.log(BillParams)
        let res = {
            type: "post",
            data: {
                ...BillParams,
                "relationId": selectedCustomerRow.id,
                "pageSize": BillPage.pageSize,
                "pageNum": BillPage.pageNum
            }
        }
        CustomerBillService.export(res)
    }
   
    return (
        <div style={{margin: "0 0 8px", display: "flex"}}>
            <div style={{width: "460px", paddingTop: "6px"}}>
              
                <Button className="margin-left-8" onClick={onExport}>导出</Button>
            </div>
            <BillModel/>
        </div>
    )
}

export default function () {
    const [{accountTypeDict}, {getAccountTypeDict}] = useModel("cmDict");

    const columns = [
        {
            title: '单据编号',
            dataIndex: 'documentNumber',
            align: 'left',
        },
        {
            title: '单据类型',
            dataIndex: 'documentType',
        },
        {
            title: '记账日期',
            dataIndex: 'createTime',
        },
        {
            title: '业务员',
            dataIndex: 'createUser',
        },
        {
            title: '单据金额',
            dataIndex: 'amountReceivable',
        },
        {
            title: '平账金额',
            dataIndex: 'balanceAmount',
        },
        {
            title: '平帐账户',
            dataIndex: 'balanceAccount',
            render: (text, record) => {
                return (
                    <span>
                        {
                            accountTypeDict.map((item) => {
                                if (item.key == text) {
                                    return item.label
                                }
                            })
                        }
                    </span>
                )
            }
        },
        {
            title: '平账日期',
            dataIndex: 'updateTime',
        },
        {
            title: '平账人',
            dataIndex: 'updateUser',
        },
        {
            title: '收款状态',
            dataIndex: 'collectionStatus',
            render: text => <span>{text == 1 ? "已收款" : "未收款"}</span>,
        },
        {
            title: '财务备注',
            dataIndex: 'remarks',
        },
    ];
    const [{
        BillTable, BillTableKey, selectedCustomerRow, BillList, BillPage, BillParams, tabsKey
    }, {
        setBillTable, setBillTableKey, loadBillList
    }] = useModel('customerBill')
    useEffect(() => {
        if (tabsKey === "putBill") {
            let data = {
                relationId: selectedCustomerRow.id
            }
            loadBillList({showMsg: false, data})
        }
    }, [tabsKey])
    const onPageChange = (page, pageSize) => {
        // console.log(page, pageSize)
        const params = {...BillParams};
        params.pageNum = page;
        params.pageSize = pageSize;
        params.relationId = selectedCustomerRow.id
        // console.log(params)
        loadBillList({data: params})
        // loadCustomerList({showMsg: false, data: params});        
    }
    return (
        <>
            <CardSearch/>
            <TableHeader/>
            <Table
                columns={columns}
                dataSource={BillList}
                bordered
                pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: BillPage.total,
                    current: BillPage.pageNum
                }}
                rowKey="id"
                rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys, selectedRows) => {
                        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        // console.log(selectedRowKeys)
                        setBillTable(selectedRows)
                        setBillTableKey(selectedRowKeys)
                        // console.log([1,2,3])
                    },
                    getCheckboxProps: record => ({
                        disabled: record.collectionStatus === 1,
                        name: record.id,
                    }),
                    selectedRowKeys: BillTableKey
                }}
                scroll={{x: 'max-content'}}
            />
        </>
    );
}